import React from 'react';
import { Button } from 'antd';
import s from './s.module.less';
import { TContentMgmt } from '../../../type';
import { ServerMeta } from 'types/common';

interface ContentItemProps {
    link?: string;
    content?: TContentMgmt;
    condition?: ServerMeta;
    onEdit: () => void;
}

const ContentItem: React.FC<ContentItemProps> = ({
    link,
    content,
    condition,
    onEdit,
}) => {
    return (
        <div className={s.contentItem}>
            <div className={s.header}>
                <h3 className={s.title}>{condition?.content}</h3>
                <Button
                    onClick={onEdit}
                >
                    Edit
                </Button>
            </div>

            <div className={s.content}>
                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Link</div>
                    <div className={s.dataValue}>{link}</div>
                </div>

                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Title</div>
                    <div className={s.dataValue}>{content?.title}</div>
                </div>

                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Summary</div>
                    <div className={s.dataValue}>{content?.summary}</div>
                </div>

                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Medical disclaimer content</div>
                    <div className={s.dataValue}>{content?.medicalDisclaimerContent}</div>
                </div>

                <div className={s.dataBlock}>
                    <div className={s.dataLabel}>Main content</div>
                    <div className={s.dataValue}>{content?.mainContent}</div>
                </div>
            </div>
        </div>
    );
};

export default ContentItem;
